<style scoped>
.chips-container {
  border-style: inset;
  min-height: 56px;
  padding: 8px;
}
.chip-item {
  margin: 4px;
}
</style>

<template>
  <div>
    <input type="file" id="file" ref="file" @change="onFileAdd" multiple class="display-none"/>
    <span v-if="!isSubmitted">
      <mu-circular-progress :size="24" v-if="uploading" class="vertical-align-middle"></mu-circular-progress>
      <mu-button color="primary" small @click="onClickAdd" v-else-if="!simpleMode"><mu-icon value="add" />{{$t('attachment.add')}}</mu-button>
      <mu-button icon @click="onClickAdd" v-else small><mu-icon value="attachment"></mu-icon></mu-button>
      <mu-button color="secondary" small @click="onClickDeleteAll" :disabled="!attachmentIds.length" v-if="!simpleMode"><mu-icon value="delete" />{{$t('attachment.deleteAll')}}</mu-button>
    </span>
    <component :is="simpleMode ? 'span' : 'div'" :class="!simpleMode ? 'chips-container' : ''">
      <AttachmentItem :simpleMode="simpleMode" v-for="(attachment, index) in attachments" :attachment="attachment" @onDelete="onDelete(index)" :isSubmitted="isSubmitted"/>
    </component>
  </div>
</template>

<script>
import langEn from './lang/en.json'
import langZh from './lang/zh.json'

import axios from "axios";

import AttachmentItem from '@/components/Common/AttachmentItem.vue'

export default {
  name: 'AttachmentBrowser',
  components: {
    AttachmentItem
  },
  props: {
    initIds: {
      type: Array,
      default: () => {
        return [];
      }
    },
    isSubmitted: {
      type: Boolean,
      default: false
    },
    simpleMode: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      // Object
      files: [],
      attachmentIds: this.initIds,
      attachments: [],
      colors: ["red", "pink", "purple", "deepPurple", "indigo", "blue", "lightBlue", "cyan", "teal", "green", "lightGreen", "lime", "yellow", "amber", "orange", "deepOrange", "brown", "blueGrey", "grey"],
      uploading: false,
    }
  },
  computed: {
    // Store
    triggerRefresh() {
      return this.$store.getters.triggerRefresh;
    },

    // DOM
    file() {
      return this.$refs.file;
    },
  },
  watch: {
    triggerRefresh() {
      this.fetchAttachments();
    },
    attachmentIds() {
      this.fetchAttachments();
    },
    initIds(newValue) {
      this.attachmentIds = newValue;
      this.fetchAttachments();
    },
  },
  created() {
    this.fetchAttachments();
  },
  mounted() {
    this.$i18n.add('en', langEn);
    this.$i18n.add('zh', langZh);
  },
  methods: {
    // Fetch
    fetchAttachments() {
      if(this.attachmentIds.length) {
        axios.get(this.$store.getters.urlApi + "attachment?ids=" + JSON.stringify(this.attachmentIds), {
          headers: {
            token: this.$store.state.auth.token
          }
          }
        ).then(response => {
          this.attachments = response.data.data.attachments;
        });
      } else {
        this.attachments = [];
      }
    },

    onClickAdd() {
      this.file.click();
    },
    onClickDeleteAll() {
      axios.delete(this.$store.getters.urlApi + "attachment", {
        headers: {
          token: this.$store.state.auth.token,
          'content-type': 'application/json'
        },
        params: {
          'ids': this.attachmentIds
        }
        }
      ).then(() => {
        this.attachmentIds = [];
        this.files = [];
        this.attachments = [];
        this.$emit('onUpdateAttachments', this.ids);
        this.$toast.success(this.$t('toast.delete'));
        this.$emit('triggerRefresh');
      });
    },
    onFileAdd() {
      if (this.$refs.file.files != undefined) {
        this.files = this.toArray(this.files).concat(this.toArray(this.$refs.file.files));
        this.onActionUpload(this.$refs.file.files);
      }
    },
    onActionUpload(newFiles) {
      this.uploading = true;
      const formData = new FormData();
      for(var i = 0; i < newFiles.length; i++) {
        formData.append('file[]', newFiles[i]);
      }

      axios.post(this.$store.getters.urlApi + "attachment", formData, {
        headers: {
          token: this.$store.state.auth.token
        },
        }
      ).then(response => {
        this.uploading = false;
        var i;
        for (i = 0; i < response.data.data.attachments.length; i++) {
          this.attachmentIds.push(response.data.data.attachments[i]._id);
        }
        this.$emit('onUpdateAttachments', this.attachmentIds);
        this.$emit('triggerRefresh');
        this.$toast.success(this.$t('toast.create'));
      });
    },
    onDelete(index) {
      axios.delete(this.$store.getters.urlApi + "attachment/" + this.attachmentIds[index], {
        headers: {
          token: this.$store.state.auth.token
        }
        }
      ).then(() => {
        this.attachmentIds.splice(index, 1);
        this.files.splice(index, 1);
        this.$emit('onUpdateAttachments', this.attachmentIds);
        this.$emit('triggerRefresh');
        this.$toast.success(this.$t('toast.delete'));
      });
    },

    toArray(fileList) {
      return Array.prototype.slice.call(fileList);
    },

    stringDownloadPath(item) {
      return this.$store.getters.urlStorage + item.path;
    },

    randColor() {
      var color = this.colors[Math.floor(Math.random()*this.colors.length)];
      return color;
    },
  },
}
</script>
